import {
  ADD_DATA_CATEGORY,
  ADD_DATA_CATEGORY_FAILED,
  ADD_DATA_CATEGORY_SUCCESS,

  ADD_DATASET,
  ADD_DATASET_FAILED,
  ADD_DATASET_SUCCESS,

  DELETE_DATA_CATEGORY_COMPLETE,
  DELETING_DATA_CATEGORY,

  UPDATING_DATA_CATEGORY,
  UPDATING_DATA_CATEGORY_COMPLETE,

  DELETE_SUB_DATA_CATEGORY,
  DELETE_SUB_DATA_CATEGORY_COMPLETE,

  ADD_DATA_SUB_CATEGORY,
  ADD_DATA_SUB_CATEGORY_COMPLETE,

  DELETE_DATASET,
  DELETE_DATASET_COMPLETE,

  FETCH_EXCEL_CATEGORIES,
  FETCH_EXCEL_CATEGORIES_COMPLETE,
  FETCH_EXCEL_INDICATIONS,
  FETCH_EXCEL_INDICATIONS_COMPLETE,
  FETCH_EXCEL_CHART_DATA,
  FETCH_EXCEL_CHART_DATA_COMPLETE,
  FETCH_EXCEL_YEARS,
  FETCH_EXCEL_YEARS_COMPLETE,

  FETCH_DATA_CATEGORIES,
  FETCH_DATA_CATEGORIES_COMPLETE,

  FETCH_SUB_DATA_CATEGORIES,
  FETCH_SUB_DATA_CATEGORIES_COMPLETE,

  FETCH_DATA_CATEGORY,
  FETCH_DATA_CATEGORY_COMPLETE,

  FETCH_DATASETS,
  FETCH_DATASETS_COMPLETE,

  FETCH_DATA_VALUES,
  FETCH_DATA_VALUES_COMPLETE,

  FETCH_TRENDING_CATEGORIES,
  FETCH_TRENDING_CATEGORIES_COMPLETE,
} from "./types";
import { toast } from "react-toastify";

import {
  deleteSubDataCategory,
  addDataCategoryService,
  addDataSet,
  deleteDataCategoryService,
  updateCategoryService,
  addSubDataCategoryService,
  updateSubDataCategoryService,
  deleteDatasetService,
  fetchExcelCategoriesService,
  fetchExcelIndicationsService,
  fetchExcelChartDataService,
  fetchExcelYearsService,
  fetchDataCategoriesService,
  fetchSubDataCategoriesService,
  fetchDataSetsService,
  fetchDataValuesService,
  fetchDataCategoryService,
  fetchTrendingCategoriesService,
  exportCSVService,
} from "./api";



export const deleteDatasetAction =
  ({ token, id }) =>
    async (dispatch) => {
      try {
        dispatch({ type: DELETE_DATASET });
        await deleteDatasetService(token, id)();
        dispatch({ type: DELETE_DATASET_COMPLETE });
        toast.success('Delete Successful')
        return true;
      } catch (error) {
        dispatch({ type: DELETE_DATASET_COMPLETE })
        toast.error('Delete Failed')
      }
    };


export const addSubDataCategoryAction = ({ token, params }) => async (dispatch) => {
  dispatch({ type: ADD_DATA_SUB_CATEGORY });
  try {
    await addSubDataCategoryService(token)(params);
    dispatch({ type: ADD_DATA_SUB_CATEGORY_COMPLETE });
    toast.success('Sub category added successfully');
    return true
  } catch (error) {
    dispatch({ type: ADD_DATA_SUB_CATEGORY_COMPLETE });
    toast.error('Add sub category failed');
  }
}

export const updateSubDataCategoryAction = ({ token, params }) => async (dispatch) => {
  dispatch({ type: ADD_DATA_SUB_CATEGORY });
  try {
    await updateSubDataCategoryService(token, params.id)(params);
    dispatch({ type: ADD_DATA_SUB_CATEGORY_COMPLETE });
    toast.success('Sub category updated successfully');
    return true
  } catch (error) {
    dispatch({ type: ADD_DATA_SUB_CATEGORY_COMPLETE });
    toast.error('Update sub category failed');
  }
}

export const addDataCategoryAction =
  ({ token, params }) =>
    async (dispatch) => {
      try {
        dispatch({ type: ADD_DATA_CATEGORY });
        const response = await addDataCategoryService(token)(params);
        console.log("Create category response:", response?.data);
        dispatch({ type: ADD_DATA_CATEGORY_SUCCESS, category: response?.data });
        toast.success("Data Category Created Successfully");
        return response?.data;
      } catch (error) {
        dispatch({ type: ADD_DATA_CATEGORY_FAILED });
        toast.error("Create Data Category Failed");
        console.error("Create category error:", error);
      }
    };

export const updateDataCategoryAction = ({ token, params }) => async (dispatch) => {
  try {
    dispatch({ type: UPDATING_DATA_CATEGORY });
    await updateCategoryService({ token, id: params?.id })(params);
    dispatch({ type: UPDATING_DATA_CATEGORY_COMPLETE });

    toast.success('Update Complete')
    return true;
  } catch (error) {
    dispatch({ type: UPDATING_DATA_CATEGORY_COMPLETE });
    toast.error('Updating Failed');
  }
}

export const addDataset =
  ({ token, params }) =>
    async (dispatch) => {
      try {
        dispatch({ type: ADD_DATASET });
        await addDataSet(token)(params);
        dispatch({ type: ADD_DATASET_SUCCESS });
        toast.success("Dataset created");
        return true;
      } catch (error) {
        dispatch({ type: ADD_DATASET_FAILED });
        toast.error("Create Data Set Failed");
      }
    };

export const deleteDataCategoryAction =
  ({ token, id }) =>
    async (dispatch) => {
      try {
        dispatch({ type: DELETING_DATA_CATEGORY });
        await deleteDataCategoryService({ token, id })();
        dispatch({ type: DELETE_DATA_CATEGORY_COMPLETE });
        toast.success('Delete Successful')
        return true;
      } catch (error) {
        dispatch({ type: DELETE_DATA_CATEGORY_COMPLETE })
        toast.error('Delete Failed')
      }
    };

export const deleteSubDataCategoryAction =
  ({ token, id }) =>
    async (dispatch) => {
      try {
        dispatch({ type: DELETE_SUB_DATA_CATEGORY });
        await deleteSubDataCategory({ token, id })();
        dispatch({ type: DELETE_DATA_CATEGORY_COMPLETE });
        toast.success('Delete Successful')
        return true;
      } catch (error) {
        dispatch({ type: DELETE_SUB_DATA_CATEGORY_COMPLETE })
        toast.error('Delete Failed')
      }
    };

export const fetchExcelCategoriesAction = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_EXCEL_CATEGORIES });
    try {
      const response = await fetchExcelCategoriesService()();
      dispatch({
        type: FETCH_EXCEL_CATEGORIES_COMPLETE,
        payload: response?.data,
      });
    } catch (error) {
      dispatch({ type: FETCH_EXCEL_CATEGORIES_COMPLETE, payload: [] });
    }
  };
};

export const fetchExcelIndicationsAction = (category) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_EXCEL_INDICATIONS });
    try {
      const response = await fetchExcelIndicationsService(category)();
      dispatch({
        type: FETCH_EXCEL_INDICATIONS_COMPLETE,
        payload: response?.data,
      });
    } catch (error) {
      dispatch({ type: FETCH_EXCEL_INDICATIONS_COMPLETE, payload: [] });
    }
  };
};

export const fetchExcelChartDataAction = (params) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_EXCEL_CHART_DATA });
    try {
      const response = await fetchExcelChartDataService(params)();
      dispatch({
        type: FETCH_EXCEL_CHART_DATA_COMPLETE,
        payload: response?.data,
      });
    } catch (error) {
      dispatch({ type: FETCH_EXCEL_CHART_DATA_COMPLETE, payload: null });
    }
  };
};

export const fetchExcelYearsAction = (category) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_EXCEL_YEARS });
    try {
      const response = await fetchExcelYearsService(category)();
      dispatch({
        type: FETCH_EXCEL_YEARS_COMPLETE,
        payload: response?.data,
      });
    } catch (error) {
      dispatch({ type: FETCH_EXCEL_YEARS_COMPLETE, payload: [] });
    }
  };
};

export const fetchDataCategoriesAction = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_CATEGORIES });
    try {
      const response = await fetchDataCategoriesService()();
      dispatch({
        type: FETCH_DATA_CATEGORIES_COMPLETE,
        payload: response?.data,
      });
    } catch (error) {
      dispatch({ type: FETCH_DATA_CATEGORIES_COMPLETE, payload: [] });
    }
  };
};

export const fetchDataCategoryAction = (id) => {
  console.log('fetchDataCategoryAction called with id:', id);
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_CATEGORY });
    try {
      const response = await fetchDataCategoryService(id)();
      dispatch({
        type: FETCH_DATA_CATEGORY_COMPLETE,
        payload: response?.data,
      });
    } catch (error) {
      dispatch({ type: FETCH_DATA_CATEGORY_COMPLETE, payload: null });
    }
  };
};

export const fetchSubDataCategoriesAction = (categoryId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_SUB_DATA_CATEGORIES });
    try {
      const response = await fetchSubDataCategoriesService(categoryId)();
      dispatch({
        type: FETCH_SUB_DATA_CATEGORIES_COMPLETE,
        payload: response?.data,
      });
    } catch (error) {
      dispatch({ type: FETCH_SUB_DATA_CATEGORIES_COMPLETE, payload: [] });
    }
  };
};

export const fetchDataSetsAction = (params) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DATASETS });
    try {
      const response = await fetchDataSetsService(params)();
      dispatch({
        type: FETCH_DATASETS_COMPLETE,
        payload: response?.data,
      });
    } catch (error) {
      dispatch({ type: FETCH_DATASETS_COMPLETE, payload: [] });
    }
  };
};

export const fetchDataValuesAction = (params) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_VALUES });
    try {
      const response = await fetchDataValuesService(params)();
      dispatch({
        type: FETCH_DATA_VALUES_COMPLETE,
        payload: response?.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_DATA_VALUES_COMPLETE,
        payload: { data: [], total: 0 }
      });
    }
  };
};
export const fetchTrendingCategoriesAction = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_TRENDING_CATEGORIES });
    try {
      const response = await fetchTrendingCategoriesService()();
      dispatch({
        type: FETCH_TRENDING_CATEGORIES_COMPLETE,
        payload: response?.data,
      });
    } catch (error) {
      dispatch({ type: FETCH_TRENDING_CATEGORIES_COMPLETE, payload: [] });
    }
  };
};

export const exportCSVAction = (id, categoryName = "data") => {
  return async () => {
    try {
      const response = await exportCSVService(id)();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${categoryName}.csv`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Export CSV Failed:", error);
    }
  };
};
